import React from "react";
import Check from "@mui/icons-material/Check";
import { styled } from "@mui/material/styles";

const CustomStepIconRoot = styled("div", {
    shouldForwardProp: (prop) => prop !== "active" && prop !== "completed",
})(({ theme, active, completed }) => ({
    backgroundColor: active || completed ? "#FFB347" : theme.palette.grey[300],
    color: "#26282b",
    width: 22,
    height: 22,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1,
    border: completed ? "2px solid #26282b" : "transparant",
    boxSizing: "border-box",
    animation: 'fadeInCheck 0.3s ease-out forwards',
}));


function CustomStepIcon(props) {
    const { active, completed, className } = props;
    return (
        <CustomStepIconRoot active={active} completed={completed} className={className}>
            {completed ? (
                <>
                    <Check
                        sx={{
                            fontSize: '0.75rem',
                            transform: 'scale(0.85)',
                            stroke: 'currentColor',
                            strokeWidth: 1,
                            opacity: 0,
                            animation: 'fadeInCheck 0.3s ease-out forwards',
                        }}
                    />
                    <style>
                        {`
      @keyframes fadeInCheck {
        0% {
          opacity: 0;
          transform: scale(0.5) rotate(0deg);
        }
        100% {
          opacity: 1;
          transform: scale(0.85) rotate(0deg);
        }
      }
    `}
                    </style>
                </>



            ) : (
                <div
                    style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: "white",
                    }}
                />
            )}
        </CustomStepIconRoot>
    );
}


export default CustomStepIcon;
